import * as React from "react";
import Header from "./Header";
import FileExplorer from "./FileExplorer";
import { makeStyles, tokens } from "@fluentui/react-components";

interface AppProps {
  title: string;
}

const useStyles = makeStyles({
  root: {
    minHeight: "100vh",
    backgroundColor: tokens.colorNeutralBackground3,
  },
});

const App: React.FC<AppProps> = (props: AppProps) => {
  const styles = useStyles();

  return (
    <div className={styles.root}>
      <Header logo="assets/logo-filled.png" title={props.title} message="Star Insure | Document Store" />
      <FileExplorer />
    </div>
  );
};

export default App;
